export default [
  {
    path: '/courseoutline',
    name: 'courseoutline',
    meta: { title: "课程大纲" },
    component: () => import('@/pages/course_outline/index.vue')
  },
  {
    path: '/courseoutline/cpp/:id',
    name: 'cpp',
    meta: { title: "课程大纲" },
    component: () => import('@/pages/course_outline/detail.vue')
  },
  {
    path: '/courseoutline/python/:id',
    name: 'python',
    meta: { title: "课程大纲" },
    component: () => import('@/pages/course_outline/detail.vue')
  },
  {
    path: '/courseoutline/scratch/:id',
    name: 'scratch',
    meta: { title: "课程大纲" },
    component: () => import('@/pages/course_outline/detail.vue')
  },
  {
    path: '/student/:courseID/:userID',
    component: () => import('@/pages/student/index.vue'),
    redirect: '/student/:courseID/:userID',
    children: [
      {
        path: '',
        name: 'learningreport',
        meta: { title: "学习报告" },
        component: () => import('@/pages/student/report_list.vue')
      },
      {
        path: ':reportID',
        name: 'reportlist',
        meta: { title: "报告详情" },
        component: () => import('@/pages/student/learning_report.vue')
      },
    ]
  },

  {
    path: '/learningreport/:reportID',
    name: 'learningreport',
    meta: { title: "学习报告" },
    component: () => import('@/pages/student/learning_report.vue')
  }, {
    path: '/reportlist',
    name: 'reportlist',
    meta: { title: "学习报告" },
    component: () => import('@/pages/student/report_list.vue')
  }
]
